package one.healthium.onboarding.domain.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import one.healthium.domain.common.ReviewItem
import one.healthium.domain.user.models.PersonalPlanPeriod

@Serializable
data class PlanSection(
    @SerialName("title") val title: String? = null,
    @SerialName("period") val period: PersonalPlanPeriod? = null,
    @SerialName("weight_loss_graph") val weightLossGraph: String? = null,
    @SerialName("list") val list: HighlightList? = null,
    @SerialName("happy_users") val happyUsers: HappyUsers? = null,
    @SerialName("reviews") val reviews: List<ReviewItem> = emptyList(),
)
